import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CustomerDetails } from './../../../_models/customer/customer-details.model';
import { CustomerCredit } from './../../../_models/customer/customer-credit.model';
import { AlertService, CryptoService, StagingServiceProvider, UtilServiceProvider } from './../../../_services/services';
import { Customer } from './../../../_models/customer/customer.model';
import { Global } from 'src/app/globals';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { LoadingService } from 'src/app/_services/loading.service';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  standalone: true, // Required for Angular 18's new standalone components
  imports: [
    SharedModule,
    MaterialModule
  ],
})
export class CustomerListComponent {

  customer: Customer;
  selectedCustomerDetails: CustomerDetails;
  customerCredit: CustomerCredit;

  @Input() customersDetailList: CustomerDetails[];
  @Input() forSalesOrder: boolean;
  @Output() sendResponseEventEmitter = new EventEmitter<any>();
  showRecords: boolean;
  isSalesProUser: boolean;
  // @Input() selectedEmailType: string;
  // @Input() pendingAgreementStatus: boolean;
  // @Input() isAutoPost: boolean;


  constructor(
    private globals: Global,
    private alertService: AlertService,
    private utilService: UtilServiceProvider,
    private staging: StagingServiceProvider,
    private cryptoService: CryptoService,
    private blockUI: LoadingService) {

    this.customer = new Customer();
    /****** Get and Set Sales Pro Config ********/
    this.isSalesProUser = this.cryptoService.dencryptString(localStorage.getItem('ProUser')) === 'true' ? true : false;
  }

  async customerSelect(customerDetails: any) {
    this.showRecords = false;
    this.customer.customerDetails = customerDetails;

    this.customer.customerDetails.deliveryPoints = [];
    if (this.isSalesProUser == true) {
      this.customer.customerDetails.deliveryPoints = await this.getCustomerDeliveryPoints(customerDetails.nameId);
    }
    // this.blockUI.start();
    // this.globals.signalR.FetchCustomerCreditDetails(this.customer.customerDetails.nameId);
    // this.globals.signalR.OnResponse('returnedCustomerCreditDetails', this.onFetchCustomerCreditDetails.bind(this));
    this.sendResponse();
    this.showRecords = true;
  }

  async getCustomerDeliveryPoints(customerId) {
    this.blockUI.start();
    try {
      return await this.staging.GetCustomerDeliveryPointOptions(customerId);
    } finally {
      this.blockUI.stop();
    }
  }

  onFetchCustomerCreditDetails(response: any) {
    if (response.errorMessage) {
      this.alertService.error(response.errorMessage);
      this.blockUI.stop();
      return;
    }
    response = response.transactionObject;
    this.blockUI.stop();
    this.customer.customerCredit = response;
    this.customersDetailList = null;
    this.sendResponse();
  }
  sendResponse() {
    // if (this.pendingAgreementStatus == true || this.isAutoPost == true) {
    //   let contacts: any = this.customer.customerDetails.contactDetails;
    //   if (contacts && contacts.length > 0) {
    //     contacts = contacts.filter((x: any) => x.ContactType == this.selectedEmailType) || [];
    //     contacts = contacts.filter((x: any) => x.NameID == this.customer.customerDetails.nameId) || [];
    //     if (contacts.length > 0) {
    //       contacts = contacts.filter((x: any) => this.utilService.validateEmail(x.ContactInformation) == true);
    //       this.customer.customerDetails.mailToEmails = contacts.map((x: any) => x.ContactInformation).join(";");
    //       this.customer.customerDetails.mailToEmails = this.customer.customerDetails.mailToEmails +';';
    //     }
    //   }
    // }

    this.showRecords = true;
    this.sendResponseEventEmitter.emit(this.customer);
  }
}
